import { Players } from './types';

export const symbolMap = {
  [Players.None]: '',
  [Players.Player1]: 'X',
  [Players.Player2]: 'O',
  [Players.Both]: 'Draw'
};
